if (!customElements.get('rhino-read-more')) {
  customElements.define('rhino-read-more', class extends HTMLElement {
    connectedCallback() {
      this.content = this.querySelector('.rhino-read-more__content');
      this.viewport = this.querySelector('.rhino-read-more__viewport');
      this.button = this.querySelector('.rhino-read-more__toggle');
      if (!this.content || !this.viewport || !this.button || this.observer) return;
      this.expanded = false;
      this.preview = this.querySelector('.rhino-read-more__preview') || document.createElement('div');
      this.preview.className = 'rhino-read-more__preview';
      const copy = this.content.cloneNode(true);
      copy.querySelectorAll('p,div,li,br,h1,h2,h3,h4,h5,h6,tr').forEach(element => element.append(' '));
      this.preview.textContent = copy.textContent.replace(/\s+/g, ' ').trim();
      this.viewport.prepend(this.preview);
      this.style.setProperty('--rhino-preview-lines', String(Number(this.dataset.lines) || 5));
      this.onClick = () => {
        this.expanded = !this.expanded;
        this.update();
        if (!this.expanded && this.getBoundingClientRect().top < 130) {
          this.scrollIntoView({ block: 'start', behavior: 'auto' });
        }
      };
      this.button.addEventListener('click', this.onClick);
      this.observer = new ResizeObserver(entries => {
        const width = entries[0].contentRect.width;
        if (width !== this.lastWidth) { this.lastWidth = width; this.update(); }
      });
      this.observer.observe(this.viewport);
      this.update();
      document.fonts?.ready.then(() => { if (this.isConnected) this.update(); });
    }
    update() {
      this.preview.hidden = false;
      const overflowing = this.preview.scrollHeight > this.preview.clientHeight + 1;
      this.preview.hidden = this.expanded || !overflowing;
      this.content.hidden = !this.expanded && overflowing;
      this.button.hidden = !overflowing;
      this.button.setAttribute('aria-expanded', String(this.expanded));
      this.button.querySelector('[data-read-more-label]').textContent = this.expanded ? 'Read less' : 'Read more';
      this.setAttribute('data-ready', '');
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.observer = null;
      this.button?.removeEventListener('click', this.onClick);
    }
  });
}
